module.exports = __webpack_public_path__ + "img/igk_welcome.48a43e00.jpg";